import Button from "devextreme-react/button";
import React from "react";

export interface ITaskCycleControlViewProps {
    canStartNewCycle: boolean;
    startActionLabel: string;
    busy: boolean;
    onClickStartCycle: () => void | Promise<void>;
}

// Icon-only start action for a task header, sitting beside the download icon. The label is the
// hint: the header row has no room for text, and the confirm dialog spells out what starts.
export function TaskCycleControlView({ canStartNewCycle, startActionLabel, busy, onClickStartCycle }: ITaskCycleControlViewProps) {
    if (!canStartNewCycle) return null;

    return (
        <Button
            elementAttr={{ "data-testid": "task-cycle-control", "aria-label": startActionLabel }}
            icon="refresh"
            stylingMode="text"
            hint={startActionLabel}
            disabled={busy}
            onClick={onClickStartCycle}
        />
    );
}
